import { locales } from "configs/i18n";
import i18next from "i18next";

i18next.addResources(locales.EN, "CREATE_CLIENT_FORM", {
  INPUT_TEXT: "Client Name",
  SUBMIT_BUTTON: "Create",
});
